import { Navigate, useParams } from 'react-router-dom';
import {
  ContainersViewPage,
  ContainersViewHeader,
  ContainerFormCards,
  ContainersViewTopCards,
  ContainersViewImages,
  ContainersViewDocuments,
  ContainersViewHistories,
} from './ContainersViewComponents';
import { useContainerQuery, useIsSmallScreen } from '../../hooks';
import { Repairs } from '../repairs';
import { YardPlaceSceneViewModal } from '../../design-system';

export const ContainersView = () => {
  const params: any = useParams();
  const { data: container, isFetching } = useContainerQuery(params.id);
  const isSmallScreen = useIsSmallScreen();

  if (isFetching) return <></>;
  if (!container) return <Navigate to={'/dashboard/containers'} replace />;

  return (
    <>
      <ContainersViewPage>
        <ContainersViewHeader container={container} />
        <ContainerFormCards>
          {!isSmallScreen && <ContainersViewTopCards container={container} />}
          <ContainersViewImages container={container} />
          <ContainersViewDocuments container={container} />
        </ContainerFormCards>
        {!isSmallScreen && !!container._count.repair && <Repairs containerId={params.id} />}
        {!!container.histories && !!container.histories.length && (
          <ContainersViewHistories histories={container.histories} />
        )}
      </ContainersViewPage>
      <YardPlaceSceneViewModal />
    </>
  );
};
